export const PointsLoyaltyActionType = (json: IPointLoyaltyActionType): IPointLoyaltyActionTypeModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

export const PointsLoyaltyAction = (json: IPointLoyaltyAction): IPointLoyaltyActionModel => {
	const { loyalty_activity_id, created_at, updated_at, ...rest } = json

	return {
		...rest,
		loyaltyActivityId: loyalty_activity_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Paylods
 */
const PointsLoyaltyActionSharedPayload = (
	event: IFormSubmitEvent<IPointLoyaltyActionForm>,
): IPointLoyaltyActionSharedPayload => {
	const { action, points } = event.values

	return {
		type: action,
		configuration: {
			points,
		},
	}
}

export const PointsLoyaltyActionCreateToPayload = (event: IFormSubmitEvent<IPointLoyaltyActionForm>) => {
	const shared = PointsLoyaltyActionSharedPayload(event)

	return {
		...shared,
	}
}

export const PointsLoyaltyActionUpdateToPayload = (
	updated: IPointLoyaltyActionModel,
	event: IFormSubmitEvent<IPointLoyaltyActionForm>,
) => {
	const shared = PointsLoyaltyActionSharedPayload(event)

	return {
		...shared,
		id: updated.id,
	}
}
